/**
 * @generated SignedSource<<5c66aad52ee769f0dddcb584c009dd38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingDurationCourtFragment$data = {
  readonly agenda: {
    readonly facility: {
      readonly publicBookingPermissionSet: {
        readonly customerCanSelectCourt: boolean | null | undefined;
      } | null | undefined;
    };
    readonly id: string;
  };
  readonly course?: {
    readonly courseBucket: {
      readonly id: string;
    } | null | undefined;
    readonly id: string;
  };
  readonly id: string;
  readonly time?: string;
  readonly " $fragmentSpreads": FragmentRefs<"BookingDurationCourtInnerFragment">;
  readonly " $fragmentType": "BookingDurationCourtFragment";
};
export type BookingDurationCourtFragment$key = {
  readonly " $data"?: BookingDurationCourtFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingDurationCourtFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingDurationCourtFragment",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingDurationCourtInnerFragment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseBucket",
              "kind": "LinkedField",
              "name": "courseBucket",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time",
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Agenda",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicBookingPermissionSet",
              "kind": "LinkedField",
              "name": "publicBookingPermissionSet",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customerCanSelectCourt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Slot",
  "abstractKey": "__isSlot"
};
})();

(node as any).hash = "27c3940afb23fc28ead79af7c4850e7a";

export default node;
